import React, { FC, useState, KeyboardEvent } from 'react';
import styles from './MapPin.module.css';

import pin1 from '@assets/images/map/pin1.svg';
import pin2 from '@assets/images/map/pin2.svg';
import pin3 from '@assets/images/map/pin3.svg';

export enum MapPinVariants {
    variant1 = 'variant1',
    variant2 = 'variant2',
    variant3 = 'variant3',
}

export interface MapPinProps {
    variant: MapPinVariants;
    pillName?: string;
    pillAddress?: string;
    pillTimeNumber?: number;
    pillTimeUnit?: string;
    onClick?: () => void;
}

export const MapPin: FC<MapPinProps> = ({ variant, pillName, pillAddress, pillTimeNumber, pillTimeUnit, onClick }) => {
    const [showPill, setShowPill] = useState(false);

    const handleTogglePill = () => {
        if (variant === MapPinVariants.variant3) {
            setShowPill((prev) => !prev);
            onClick?.();
        }
    };

    const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleTogglePill();
        }
    };

    const getSrc = () => {
        switch (variant) {
            case MapPinVariants.variant1:
                return pin1;
            case MapPinVariants.variant2:
                return pin2;
            case MapPinVariants.variant3:
                return pin3;
            default:
                return '';
        }
    };

    return (
        <div className={styles.mapPinContainer}>
            {variant === MapPinVariants.variant3 ? (
                <div
                    className={styles.clickablePin}
                    onClick={handleTogglePill}
                    role="button"
                    tabIndex={0}
                    onKeyDown={handleKeyPress}
                    aria-pressed={showPill}
                    aria-label={pillName || 'Toggle info'}>
                    <img src={getSrc()} alt="map pin" className={styles.svgIcon} />
                    {showPill && (
                        <div className={styles.pill}>
                            {pillTimeNumber !== undefined && pillTimeUnit && (
                                <div className={styles.pillTime}>
                                    <div className={styles.pillTimeNumber}>{pillTimeNumber}</div>
                                    <div className={styles.pillTimeUnit}>{pillTimeUnit}</div>
                                </div>
                            )}
                            <div className={styles.pillDetails}>
                                {pillName && <div className={styles.pillName}>{pillName}</div>}
                                {pillAddress && <div className={styles.pillAddress}>{pillAddress}</div>}
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <img src={getSrc()} alt="map pin" className={styles.svgIcon} />
            )}
        </div>
    );
};
